import { useEffect } from 'react';
import { removeExperiment } from '/lib/helpers';

export default function RemoveLandingExperiment() {
  useEffect(() => {
    const experimentsToRemove = [
      'experiment_landing_global_new',
      'experiment_landing_global',
      'experiment_landing_new_design',
      'experiment_v2_landing_background',
      'rotterdam_experiment',
      'landing_page_experiment',
      'landing_budapest_experiment',
      'landing_template_experiment',
      'landing_arrows_experiment',
      'landing_footer_experiment',
      'landing_headline_experiment',
      'mysmartcv_landing_experiment',
      'experiment_v2_landing_next_arrow',
      'experiment_v2_landing_cta',
      'experiment_v2_landing_sub_title',
      'experiment_v2_landing_title',
      'experiment_v2_landing_resume',
      'experiment_v2_landing_footer',
      'experiment_resume_nation_landing',
      'experiment_landing_exit_hack',
      'exp_back_button_hack',
    ];
    experimentsToRemove.forEach(removeExperiment);
  }, []);
  useEffect(() => {
    const experimentsToRemove = [
      'exp_chrome_activity',
      'exp_chrome_cta',
      'exp_page_redirect',
      'exp_landing_cta_text',
      'exp_landing_title',
      'exp_landing_hero',
      'exp_chrome_cta_master_redirect',
      'exp_chrome_logo',
      'exp_product_title',
      'exp_notification_badge',
      'exp_slider_order',
      'exp_step_image',
      'exp_slider_image',
      'exp_landing_mobile_design',
      'exp_hero_design',
      'exp_hero_landing_image',
      'exp_industry_logo',
      'exp_hero_cta',
      'exp_hero_image_d2',
      'exp_background_element_right_d2',
      'exp_background_element_left_d2',
      'exp_landing_banner',
      'exp_landing_design',
      'exp_hero_image',
      'exp_hero_title',
      'exp_hero_girl_image',
      'exp_headline_landing_title',
      'exp_cv_image_clickable',
      'exp_landing_clickable_skills_section',
      'exp_landing_cookie',
      'exp_landing_hero_image',
      'exp_landing_hero_text',
      'exp_landing_upload_resume',
      'exp_bluepill_landing',
    ];

    experimentsToRemove.forEach(removeExperiment);
  }, []);

  return null;
}
